import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import { inboxCountsMiddleware } from "../middleware/inboxCounts";

import main from "./main";
import auth from "./auth";
import home from "./home";
import signUp from "./signUp";
import listing from "./listing";
import account from "./account";
import payment from "./payment";
import payPerLead from "./payPerLead";
import proBono from "./proBono";
import proBonoDetail from "./proBonoDetail";
import callHistory from "./callHistory";
import payPerLeadDetail from "./payPerLeadDetail";
import performance from "./performance";
import referralRequests from "./referralRequests";
import referralRequestDetail from "./referralRequestDetail";
import questions from "./questions";
import messages from "./messages";
import teams from "./teams";
import searchResult from "./searchResult";
import landing from "./landing";
import publicListing from "./publicListing";
import search from "./search";
import partner from "./partner";
import communityReferrals from "./communityReferrals";
import requestTracking from "./requestTracking";
import following from "./following";

const enhancers = applyMiddleware(thunk, inboxCountsMiddleware);

const rootReducer = combineReducers({
  account,
  auth,
  callHistory,
  referralRequests,
  referralRequestDetail,
  home,
  listing,
  main,
  payment,
  payPerLead,
  proBono,
  proBonoDetail,
  payPerLeadDetail,
  performance,
  questions,
  signUp,
  messages,
  teams,
  searchResult,
  landing,
  publicListing,
  search,
  partner,
  communityReferrals,
  requestTracking,
  following
});

export default createStore(rootReducer, composeWithDevTools(enhancers));
